<template>
  <!-- eslint-disable max-len -->
  <div class="modal-parent">
    <div
      v-shortkey="['esc']"
      class="modal"
      @shortkey="closeModal"
    >
      <div class="modal_topbar modal_topbar--no-actions">
        <div
          id="title-wellness-modal"
          class="modal_topbar-title modal_topbar-title--no-actions"
        >
          BioConnect Wellness Declaration
        </div>
        <span
          id="exit-wellness-modal"
          class="modal_topbar-exit"
          @click="closeModal"
          v-html="closeIcon"
        />
      </div>
      <div class="flex-grid">
        <div class="column--two">
          <p class="wellness__description">
            In response to operational changes resulting from COVID-19, BioConnect Mobile offers the
            ability to monitor individuals who may pose potential risk to the health of your
            facility.
          </p>
          <p class="wellness__description">
            While wellness declaration is enforced, once per day a user will receive a simple survey
            prior to entering your facility.
          </p>
          <p class="wellness__description">
            Any negative responses can be sent to this account's email or a specified Slack channel.
          </p>
          <button
            class="btn btn__text btn__text--blue"
            @click="$router.push({ name: 'accountDetails' })"
          >
            Set Up Email Notifications
          </button>
          <button
            class="btn btn__text btn__text--blue"
            @click="$router.push({ name: 'webhooks' })"
          >
            Set Up Slack Notifications
          </button>
        </div>
        <div class="column--two">
          <img
            :src="wellnessGraphic"
            class="wellness-image"
          />
        </div>
      </div>
    </div>
    <div class="modal-overlay" />
  </div>
  <!-- eslint-enable max-len -->
</template>

<script>
import feather from 'feather-icons'
import wellnessGraphic from '@/assets/WellnessGraphic.png'

export default {
  name: 'WellnessInfoModal',
  data() {
    return {
      closeIcon: feather.icons.x.toSvg(),
      wellnessGraphic,
    }
  },
  methods: {
    closeModal() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
.wellness {
  &-image {
    width: 100%;
    height: auto;
  }
  &__description {
    font-weight: 300;
    margin-top: 0;
    margin-bottom: 1em;
    line-height: 1.7em;
  }
}
</style>
